/**
 * forecast2026.js — backwards-compat shim.
 *
 * Forecast data is now stored multi-year in forecast.js (2026-2031).
 * This file re-exports the 2026 slice in the legacy shape for any consumers
 * that still import from here. New code should import from './forecast'.
 */

import { forecastByYear, MONTHS as MONTHS_FROM_NEW } from './forecast';

export const FY = 2026;

export const MONTHS = MONTHS_FROM_NEW;

// Same shape the old file exported: { childDept: [Jan..Dec] }
export const forecast2026 = forecastByYear[2026];

const sum12 = (arr) => arr.reduce((a, b) => a + b, 0);

export const forecast2026Annual = Object.fromEntries(
  Object.entries(forecast2026).map(([dept, months]) => [dept, sum12(months)])
);

export const forecast2026Total = Object.values(forecast2026Annual).reduce((a, b) => a + b, 0);
